import * as THREE from 'three';
import { TweenMax as TM } from 'gsap';
import vertexShader from '../glsl/vertexShader';
import fragmentShader from '../glsl/fragmentShader.glsl';
import offset from '../functions/offset';

export default class Figure {
  constructor($image, scene, geometry) {
    this.$image = $image;
    this.scene = scene;
    this.geometry = geometry;
    this.$image.style.opacity = 0;
    this.top = 0;

    this.loader = new THREE.TextureLoader();
    this.sizes = new THREE.Vector2(0, 0);
    this.offset = new THREE.Vector2(0, 0);
    this.mouse = new THREE.Vector2(0, 0);

    this.hover = this.loader.load(this.$image.dataset.hover);
    this.image = this.loader.load(this.$image.dataset.src, () => {
      this.setFilters([this.hover, this.image]);
    });

    window.addEventListener('mousemove', ev => {
      this.onMouseMove(ev);
    });
  }

  start() {
    this.getSizes();
    this.createMesh();
  }

  getSizes() {
    const { width, height, left } = this.$image.getBoundingClientRect();
    const topOffset = offset(this.$image, this.top, false);

    this.sizes.set(width, height);

    this.offset.set(
      left - window.innerWidth / 2 + width / 2,
      -topOffset + window.innerHeight / 2 - height / 2
    );
  }

  setFilters(textureArr) {
    textureArr.forEach(texture => {
      texture.minFilter = THREE.LinearFilter;
      texture.magFilter = THREE.LinearFilter;
    });
  }

  createMesh() {
    this.uniforms = {
      u_image: { type: 't', value: this.image },
      u_imagehover: { type: 't', value: this.hover },
      u_mouse: { value: this.mouse },
      u_time: { value: 0.0 },
      u_res: {
        value: new THREE.Vector2(window.innerWidth, window.innerHeight)
      }
    };

    this.material = new THREE.ShaderMaterial({
      uniforms: this.uniforms,
      vertexShader: vertexShader,
      fragmentShader: fragmentShader,
      defines: {
        PR: window.devicePixelRatio.toFixed(1)
      }
    });

    this.mesh = new THREE.Mesh(this.geometry, this.material);
    this.mesh.scale.set(this.sizes.x, this.sizes.y, 1);
    this.mesh.position.set(this.offset.x, this.offset.y, 0);
    this.scene.add(this.mesh);
  }

  updateDependentUniforms() {
    this.uniforms.u_res.value = new THREE.Vector2(
      window.innerWidth,
      window.innerHeight
    );
  }

  updateMesh() {
    this.top = 0;

    this.getSizes();

    this.mesh.scale.set(this.sizes.x, this.sizes.y, 1);
    this.mesh.position.set(this.offset.x, this.offset.y, 0);

    this.updateDependentUniforms();
  }

  onMouseMove(event) {
    if (!this.mesh) {
      return;
    }
    TM.to(this.mouse, 0.25, {
      x: (event.clientX / window.innerWidth) * 2 - 1,
      y: -(event.clientY / window.innerHeight) * 2 + 1
    });
  }

  update() {
    if (!this.uniforms) {
      return;
    }
    this.uniforms.u_time.value += 0.01;
  }
}
